import { logError, LogErrorMetrics } from '../tracking/felog'
import { transformToObject } from './error'

const isTouch = (): boolean => {
  return (
    (typeof window !== 'undefined' && 'ontouchstart' in window) ||
    // #ToDo improve typings to avoid any. Do we actually need to check for msMaxTouchPoints?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || (navigator as any).msMaxTouchPoints))
  )
}

export const isTouchDevice = (): boolean => {
  try {
    if (IS_CLIENT_SIDE) {
      return isTouch()
    }
  } catch (e) {
    void logError('Touch device detection failed', LogErrorMetrics.TouchDeviceDetectionFailed, {
      error: transformToObject(e as Error),
    })
  }

  return false
}
